// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","backdrop":"styles_backdrop__qY1Tn","bottom":"styles_bottom__QyJPp","right":"styles_right__W3Gvw","children":"styles_children__4H_bt"};